import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HideOpenElementsService {
    private _hideOpenElementsSubject = new Subject<void>();
    public hideOpenElementsStream: Observable<void> = this._hideOpenElementsSubject.asObservable();

    constructor() {
        SingletonServiceGuard.register('HideOpenElementsService');
    }

    public hideOpenElements(): void {
        this._hideOpenElementsSubject.next();
    }
}
